import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { isBetaRoute } from "./routing";
import "./styles.css";

async function renderRoute() {
  const root = createRoot(document.getElementById("root")!);
  if (isBetaRoute(window.location.pathname)) {
    const { BetaPage } = await import("./BetaPage");
    root.render(<StrictMode><BetaPage /></StrictMode>);
    return;
  }

  const { App } = await import("./App");
  root.render(<StrictMode><App /></StrictMode>);
}

void renderRoute();
